import { render, staticRenderFns } from "./IngredientGroup.vue?vue&type=template&id=0bfc358a&scoped=true&"
import script from "./IngredientGroup.vue?vue&type=script&lang=js&"
export * from "./IngredientGroup.vue?vue&type=script&lang=js&"
import style0 from "./IngredientGroup.vue?vue&type=style&index=0&id=0bfc358a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfc358a",
  null
  
)

export default component.exports